import { IMainPageAction, TMainPageState } from '../../types/mainpage';
import { MAINPAGE_DEFAULT_STATE } from '../../constants/mainpage/defaultState';

const defaultAction: IMainPageAction = {
  type: '',
};

export function mainpageReducer(state = MAINPAGE_DEFAULT_STATE, _action = defaultAction): TMainPageState {
  return state;
}
